import { useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { ListContainer, ListContent } from '~/components/PageLayout';
import { Layout } from './components';

export const DeviceAuditLogs = () => {
  const params = useParams<{ deviceId: string }>();
  const deviceId = parseInt(params.deviceId ?? '');

  return (
    <Layout noPadding>
      <ListContainer>
        <ListContent>
          <AuditLogList recordTypes={['Device']} deviceId={deviceId} fullHeight />
        </ListContent>
      </ListContainer>
    </Layout>
  );
};
